export default __webpack_public_path__ + "4255db4ec924d1fc7781b868f364298c.png";